import { Button, Space, message, Drawer, Modal, Dropdown } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { getPrimaryKeyOfModule, Api as FetchAPI } from '@/utils';
import SpBusinessBtn from '@/components/sp-business-btns/sp-business-btn';
import OfficialHeader from '@/asset/AssetTaskTable/components/OfficialHeader';
import ExportButton from '../components/ExportButton';
import ImportButton from '../components/ImportButton';
import UploadButton from '../components/UploadButton';
import HeadAddButton from '../components/HeadAddButton';
import HeadDeleteButton from '../components/HeadDeleteButton';
import useHeadButtonConfig from './useHeadButtonConfig';
import { ButtonLayout } from '@/asset/AssetTask/templates/Cascade/components';


const useHeadBtnsList = (props) => {
  const {
    utils,
    taskId,
    headerBtns,
    selectedRows,
    setSelectedRows,
    rowSelection,
    tableWithRef,
    reload,
    isHaveAdd,
    optionsActionType,
    moduleInfo,
    btnInfo,
    btnsClick,
    moduleID,
    namespaceID,
    filter,
    searchParams,
    sorter,
    mergeColumns,
    mergeRequest,
    requestParams,
    addEditRecord,
    editableRef,
    canImport,
    mergeRowKey,
    fileConfig,
    fileModule,
    isMobile,
  } = props;
  const headButtonConfig = useHeadButtonConfig({
    headerBtns,
    btnInfo,
    canImport,
    fileModule,
    moduleID,
  });

  const { mainBtns, moreBtns, mobileMainBtns, mobileMoreBtns } = headButtonConfig;

  const btnRender = (btn) => {
    if (btn.id === 'add-btns') {
      return (
        <HeadAddButton
          isHaveAdd={isHaveAdd}
          taskId={taskId}
          utils={utils}
          optionsActionType={optionsActionType}
          reload={reload}
        />
      );
    }
    if (btn.id === 'delete-btns') {
      return (
        <HeadDeleteButton
          taskId={taskId}
          tableWithRef={tableWithRef}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          optionsActionType={optionsActionType}
          reload={reload}
          moduleInfo={moduleInfo}
        />
      );
    }
    if (btn.id === 'export-btns') {
      return (
        <ExportButton
          moduleInfo={moduleInfo}
          mergeColumns={mergeColumns}
          selectedRows={selectedRows}
          rowSelection={rowSelection}
          request={mergeRequest}
          namespaceID={namespaceID}
          moduleID={moduleID}
          filter={filter}
          requestParams={requestParams}
          searchParams={searchParams}
          sorter={sorter}
        />
      );
    }
    if (btn.id === 'import-btns') {
      return (
        <ImportButton
          moduleInfo={moduleInfo}
          columns={mergeColumns}
          isMobile={isMobile}
          reload={reload}
        />
      );
    }
    if (btn.id === 'upload-btns') {
      return (
        <UploadButton
          namespaceID={namespaceID}
          moduleID={moduleID}
          moduleInfo={moduleInfo}
          FetchAPI={FetchAPI}
          reload={reload}
          addEditRecord={(...arg) => {
            addEditRecord(...arg);
            setImmediate(() => {
              editableRef.current?.validateFields();
            });
          }}
          mergeRowKey={mergeRowKey}
          fileConfig={fileConfig}
          isMobile={isMobile}
        />
      );
    }
    if (btn.btnConfig) {
      return (
        <SpBusinessBtn
          {...props}
          key={`${btn!.id}`}
          btnInfo={btn.btnConfig}
          btnsClick={btnsClick}
          isMobile={isMobile}
        />
      );
    }
  };
  const dropbtns = (
    <Dropdown
      dropdownRender={() => (
        <Space>
          <Space.Compact direction="vertical">
            {moreBtns.map((btn) => (
              btnRender(btn)
            ))}
          </Space.Compact>
        </Space>
      )}
    >
      <ButtonLayout>更多</ButtonLayout>
    </Dropdown>
  );
  const headBtns = (
    <>
      {
        mainBtns.map((btn) => (
          btnRender(btn)
        ))
      }
      {
        moreBtns.length > 0 ? dropbtns : null
      }
    </>
  );
  const mobileDropbtns = (
    <Dropdown
      trigger={['click']}
      dropdownRender={() => (
        <Space>
          <Space.Compact direction="vertical">
            {mobileMoreBtns.map((btn) => (
              btnRender(btn)
            ))}
          </Space.Compact>
        </Space>
      )}
    >
      <ButtonLayout>更多</ButtonLayout>
    </Dropdown>
  );
  const mobileHeadBtns = (
    <Space>
      {
        mobileMainBtns.map((btn) => (
          btnRender(btn)
        ))
      }
      {
        moreBtns.length > 0 ? mobileDropbtns : null
      }
    </Space>
  );
  return () => {
    return isMobile ? mobileHeadBtns : headBtns;
  };
};
export default useHeadBtnsList;
